import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var RESET_PARENT_HTML_ATTRIBUTE = "consent-cb-reset-parent";
var RESET_PARENT_HTML_ATTRIBUTE_VALUE = "1";
var KNOWN_RATIO_CLASSES = {
  // Elementor
  asSuffix: "-fit-aspect-ratio",
  // Gutenberg
  gutenberg: "wp-block-embed__wrapper",
  // Cornerstone
  cornerstone: "x-frame-inner"
};
/**
 * In some cases it is necessary to reset some styles which are not resettable through
 * the `style` attribute. E.g. pseudo-classes like `::before` and `::after`.
 */

function applyContentBlockRatioCssPlainCss() {
  var element = document.createElement("style");
  element.style.type = "text/css";
  document.getElementsByTagName("head")[0].appendChild(element);
  var attribute = "".concat(RESET_PARENT_HTML_ATTRIBUTE, "=\"").concat(RESET_PARENT_HTML_ATTRIBUTE_VALUE, "\"");
  var rules = [].concat(_toConsumableArray([// Thrive Architect
  ".thrv_wrapper[".concat(attribute, "]"), // Ultimate Video (WP Bakery Page Builder)
  ".ultv-video__outer-wrap[".concat(attribute, "]")].map(function (s) {
    return "".concat(s, "::before{display:none!important;}");
  })), _toConsumableArray([// JetElements for Elementor
  ".jet-video[".concat(attribute, "]>.jet-video__overlay"), // Divi Page Builder
  ".et_pb_video[".concat(attribute, "]>.et_pb_video_overlay"), // Ultimate Video (WP Bakery Page Builder)
  ".ult-video[".concat(attribute, "]>.ultv-video"), // Astra Theme (Gutenberg Block)
  ".wp-block-embed__wrapper[".concat(attribute, "]>.ast-oembed-container")].map(function (s) {
    return "".concat(s, "{display:none!important;}");
  })), [// Other rules: If you add a similar one, please merge to an array!
  // Gutenberg
  ".wp-block-embed__wrapper[".concat(attribute, "]::before{padding-top:0!important;}"), // Thrive Architect
  ".tve_responsive_video_container[".concat(attribute, "]{padding-bottom:0!important;}"), // JetElements for Elementor
  ".jet-video[".concat(attribute, "]{background:none!important;}")]);
  element.innerHTML = rules.join("");
}

export { applyContentBlockRatioCssPlainCss, RESET_PARENT_HTML_ATTRIBUTE, RESET_PARENT_HTML_ATTRIBUTE_VALUE, KNOWN_RATIO_CLASSES };